<template>
  <div class="xit-action-buttons btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
    
    <div class="btn-group mr-2" role="group" aria-label="Back">
      <button @click.stop="backToMainMenu" class="btn btn-outline-primary" type="button" data-toggle="tooltip" :data-original-title="back">
        <i class="fas fa-step-backward back_button_icon"></i>
      </button>
    </div>
    
    <div class="btn-group mr-2" role="group" aria-label="Auto Arrage">
      <button 
        type="button"
        class="btn btn-outline-primary"
        @click.stop="handleAutoArrangeOfNodes" 
        data-toggle="tooltip" 
        :data-original-title="rearrange"
      >
        <i class="fa fa-compress-arrows-alt rearrange_button_icon"></i>
      </button>
    </div>

    <div class="btn-group mr-2" role="group" aria-label="Save">
      <button 
        type="button"
        class="action-button-save btn btn-outline-primary"
        @click.stop="handleSave" 
        data-toggle="tooltip" 
        :data-original-title="save"
      >
        <i class="fas fa-save save_button_icon"></i>
      </button>
    </div>

    <div class="btn-group" role="group" aria-label="page-nfo">
      <a 
        :href="media_url"
        target="_blank"
        class="btn btn-outline-primary"
      >
        <span v-if="instagram_bot_addon">IG: {{ page_name_or_insta_username }}</span>
        <span v-else>FB: {{ page_name_or_insta_username }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import Toast from 'izitoast'
import { App } from '../../App'
import { 
  showWarning,
  showError,
  showAjaxError, 
  checksNodesAreConnected,
  addClassIfNodesHaveNoValue,
  addClassIfOutputHasNoConnection,
  warnIfSequenceSingleHasNonPromotionalValue,
} from '../../functions/utils'

import { lang } from '../../assets/lang'
import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'

export default {
  data: () => ({
    back: lang.others_buttons_title_back,
    save: lang.others_buttons_title_save,
    rearrange: lang.others_buttons_title_rearrange,
    instagram_bot_addon: !! window.xitFlowBuilderData.instagram_addon,
    page_name_or_insta_username: window.xitFlowBuilderData.page_name_or_insta_username,
    media_url: window.xitFlowBuilderData.instagram_addon 
      ? 'https://www.instagram.com/' + window.xitFlowBuilderData.page_name_or_insta_username
      : 'https://facebook.com/' + window.xitFlowBuilderData.fb_page_id
  }),

  methods: {
    handleSave(event) { // eslint-disable-line

      const nodeCount = App.editor.nodes.length
      if (1 === nodeCount) {
        showWarning(lang.others_buttons_msg_components_required)
        return
      }

      if (checksNodesAreConnected('node--has-no-connection')) {
        showWarning(lang.others_buttons_msg_components_components_connection_required)
        return
      }

      if (addClassIfNodesHaveNoValue('node--has-no-value')) {
        showWarning(lang.others_buttons_msg_components_components_data_required)
        return
      }

      if (addClassIfOutputHasNoConnection(CONST_COMPONENT.POSTBACK_NEW, CONST_SOCKET.NEW_POSTBACK_OUTPUT, 'node--has-no-value')) {
        showWarning(lang.others_buttons_msg_components_new_postback_next_connection_required)
        return
      }

      if (addClassIfOutputHasNoConnection(CONST_COMPONENT.USER_INPUT_FLOW_SINGLE, CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT, 'node--has-no-value')) {
        showWarning(lang.plugin_incompatible_connection_user_input_flow_builder)
        return
      }

      if (warnIfSequenceSingleHasNonPromotionalValue('node--has-no-value')) {
        showWarning(lang.others_buttons_msg_components_non_promotional_data_required)
        return 
      }

      var page_table_id = window.xitFlowBuilderData.page_table_id
      var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
      
      const baseUrl = window.xitFlowBuilderData.base_url
      const builder_table_id = window.xitFlowBuilderData.builder_table_id
      let data = App.editor.toJSON()
      data = JSON.stringify(data)
      
      const saveButtonElement = $('.xit-action-buttons .action-button-save')

      saveButtonElement.remove('btn-outline-primary')
      saveButtonElement.add('btn-primary', 'disabled', 'btn-progress')

      $.ajax({
        method: 'POST',
        dataType: 'JSON',
        url: baseUrl + 'visual_flow_builder/flowbuilder_submit',
        data: {page_table_id,builder_table_id,instagram_bot_addon,flow_data:data},
        success: function(response) {
          saveButtonElement.remove('btn-primary', 'disabled', 'btn-progress')
          saveButtonElement.add('btn-outline-primary') 

          if(response.status == '0') {
            showError(response.message)
          } else {
            window.hasXitFlowBuilderData = true

            Toast.success({
              title: lang.utils_title_success,
              message: response.message,
              position: 'bottomRight' 
            })
          }

          return false
        },

        // eslint-disable-next-line
        error:function(xhr, status) {
          saveButtonElement.remove('btn-primary', 'disabled', 'btn-progress')
          saveButtonElement.add('btn-outline-primary') 
          showAjaxError(xhr)

          return false
        }
      })

      return false
    },

    handleAutoArrangeOfNodes (event) {
      event.preventDefault()

      const node = App.getDefaultComponent()
      node.position = [-450, -50]

      App.editor.trigger('arrange', { node })

      return false
    },

    backToMainMenu ()
    {
      const go_back_link = window.xitFlowBuilderData.go_back_link
      window.location.replace(go_back_link);
    },
  },

  mounted() {
    $('[data-toggle="tooltip"]').tooltip()

    const that = this

    $(document).on('keydown', function(event) {
      if(event.ctrlKey && (event.which === 83)) {
        that.handleSave(event)
        return false
      }
    })
  },

  beforeDestroy() { // eslint-disable-line
    const tooltip = $('[data-toggle="tooltip"]')
    if (tooltip) {
      $('[data-toggle="tooltip"]').tooltip('dispose')
    }
  },
}
</script>

<style>
.xit-action-buttons {
  position: absolute;
  right: 0;
  background-color: #fff !important;
}
</style>